export default {
  bigTitle: '进度查询',
  searchTip: '请输入邮箱地址和留言编号以查询留言进度！',
  emailPlaceholder: '邮箱',
  caseNumberPlaceholder: '留言编号',
  caseNumberTitle: '留言编号',
  statusMap: {
    0: { text: '待处理', color: 'orange' },
    1: { text: '已处理', color: '#00a4ff' },
    5: { text: '已完结', color: '#67c23a' },
  },
  tableTitle: '以下是留言的详细信息：',
  tableHeadLabel: {
    type: '类型',
    username: '姓名',
    company: '公司',
    job: '职务',
    phone: '电话',
    email: '邮箱'
  },
  messageContentLabel: {
    time: '留言时间',
    desc: '内容描述',
    file: '附件'
  },
  title01: '留言回复',
  txt01: '回复',
  activeTips: '如果您的问题已经处理并解决，您可以关闭此次留言！',
  closeBtnTxt: '关闭',
  addMessageBtnTxt: '追加留言',
  closeDialog: {
    title: '提示',
    tips: '您确认要关闭此次留言吗?',
    cancalBtn: '取消',
    confirmBtn: '关闭',
    successTip: '关闭成功！',
  },
  closedTips: {
    title: '留言已关闭，感谢您的反馈！',
    contactUsTxt: '如果您还有其他新的问题，可以重启一条留言记录或联系无锡凯尔克客户服务部：',
    contactUsList: [
      { label: '电话：', value: '+86-510-885882008', workingTime: '（周一至周五，上午8:30 - 下午4:30）', icon: require("@/assets/images/callMe/phone_color_icon.png") },
      { label: '热线：', value: '+86-189-6183-2100（24/7）', icon: require("@/assets/images/callMe/online_color_icon.png") },
      { label: '邮箱：', value: 'info@kelkflow.com.cn', icon: require('@/assets/images/callMe/email_color_icon.png') },
    ],
  },
  textareaPlaceholder: '请输入留言内容，我们将尽快与您联系。',
  submitBtnTxt: '提交',
  messageSubmitCheckTxt: {
    messageTips: '请填写留言内容',
    emailTips: '请输入邮箱地址',
    caseNumberTips: '请输入留言编号',
    successTip: '留言成功！'
  }
}


// WEBPACK FOOTER //
// ./src/config/lang/zh-CN/messageRecord.js